export const DB_VERSION = 5; // Incremented for screenshots store
export const version = "2.0.0";
export const IS_UNDER_CONSTRUCTION = false;
export const DISABLE_ASSET_PACK_IMPORT_EXPORT = true;

export const MIN_UNDO_STATES = 30;

export const MAX_ENVIRONMENT_OBJECTS = 5000;

export const ENVIRONMENT_OBJECT_Y_OFFSET = -0.5;